import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from '../../utils/axiosBaseQuery';
import { AssetGroupAvailability } from '../types';
import { serializeQueryArgsWithTenant } from '../tenantCacheKey';

// Define the API response type based on actual response
interface GetAssetGroupAvailabilitiesQuery {
    id: string;
    name: string;
    lang_names: Record<string, { title: string, description: string }>;
    priceCategory: string;
    locationId: string;
    compartmentTypes: string[];
    description: string;
    isFullDay: boolean;
    availability: AssetGroupAvailability;
}

export const groupApiSlice = createApi({
    reducerPath: 'assetGroupApiSlice',
    serializeQueryArgs: serializeQueryArgsWithTenant,
    baseQuery: axiosBaseQuery(),
    tagTypes: ['AssetGroupWithAvailabilities'],
    endpoints: (builder) => ({
        // Get availabilities for a specific group
        getAssetGroupAvailabilities: builder.query<
            GetAssetGroupAvailabilitiesQuery,
            { groupId: string, fromDate: string, toDate: string }
        >({
            query: ({ groupId, fromDate, toDate }) => ({
                url: `/group/${groupId}/availabilities/from/${fromDate}/to/${toDate}`,
                method: 'GET',
            }),
            providesTags: (result, error, { groupId }) => [
                { type: 'AssetGroupWithAvailabilities', id: groupId },
            ],
        }),
    }),
});

export const {
    useGetAssetGroupAvailabilitiesQuery,
} = groupApiSlice;
